import { RobotOutlined } from '@ant-design/icons';
import { LanguageTag } from '@framework/i18n';
import { Button } from 'antd';
import React from 'react';
import { useTranslationWithAI } from './translations/useTranslationWithAI';

interface IAiTranslationButtonProps {
  inquiryId: string;
  languageTag: LanguageTag;
}

/**
 * Pulsante per tradurre con AI
 */
export function AiTranslationButton(props: IAiTranslationButtonProps) {
  const { inquiryId, languageTag } = props;
  const { handleTranslateAI, isLoading } = useTranslationWithAI(
    inquiryId,
    languageTag,
  );

  return (
    <Button
      size="large"
      color="primary"
      variant="outlined"
      block
      icon={<RobotOutlined />}
      loading={isLoading}
      onClick={handleTranslateAI}
    >
      Traduci con AI
    </Button>
  );
}
